import { render, staticRenderFns } from "./salarySlip.vue?vue&type=template&id=2c8ccd1a"
import script from "./salarySlip.vue?vue&type=script&lang=js"
export * from "./salarySlip.vue?vue&type=script&lang=js"
import style0 from "./salarySlip.vue?vue&type=style&index=0&id=2c8ccd1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports